export interface DisabledCriteria {
    condition: boolean;
    reason?: string;
}

export interface DisabledCriteriaResult {
    isDisabled: boolean;
    reason?: string;
}

export const getDisabledCriteria = (disabledCriteria: DisabledCriteria[], addReasonSuffix?: boolean): DisabledCriteriaResult => {
    const filter = disabledCriteria.filter(dc => dc.condition);
    let reason = filter.length > 0 ? filter[0].reason : undefined;
    if (reason && addReasonSuffix) { reason = `Disabled as ${reason}`; }
    return {
        isDisabled: filter.length > 0,
        reason
    };
}
